import axios from "axios";
import React, { useEffect, useState } from "react";
import LineIcon from "react-lineicons";
import { NavLink } from "react-router-dom";
import Person from "../components/Person";

interface Information {
  name: string;
  brandImage: string;
  [key: string]: any; // For other potential properties from the API
}

const Header: React.FC = () => {
  const [information, setInformation] = useState<Information>({
    name: "",
    brandImage: "",
  });
  const [navigationToggler, setNavigationToggler] = useState<boolean>(false);

  const handleNavigationToggler = (): void => {
    setNavigationToggler(!navigationToggler);
  };

  useEffect(() => {
    axios.get<Information>("/api/information").then((response) => {
      setInformation(response.data);
    });
  }, []);

  return (
    <nav className={navigationToggler ? "mi-header is-visible" : "mi-header"}>
      <button
        onClick={handleNavigationToggler}
        className="mi-header-toggler"
        aria-label="Toggle Navigation"
        title="Toggle Navigation"
      >
        {!navigationToggler ? (
          <LineIcon name="menu" />
        ) : (
          <LineIcon name="close" />
        )}
      </button>
      <div className="mi-header-inner">
        <Person
          name={information.name}
          image={information.brandImage}
          link="/"
        />

        <ul className="mi-header-menu">
          <li>
            <NavLink to="/" end>
              <span>Home</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/about">
              <span>About</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/services">
              <span>Services</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/cv">
              <span>CV</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/blog">
              <span>Blog</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/portfolio">
              <span>Portfolio</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/showcase">
              <span>Showcase</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/contact">
              <span>Contact</span>
            </NavLink>
          </li>
        </ul>
        <p className="mi-header-copyright">
          &copy; {new Date().getFullYear()}{" "}
          <b>
            <a
              rel="noopener noreferrer"
              target="_blank"
              href="https://nathanhensher.dev"
            >
              Nathan Hensher
            </a>
          </b>
        </p>
      </div>
    </nav>
  );
};

export default Header;
